import { render, staticRenderFns } from "./LatestCategoryItem.vue?vue&type=template&id=0995bb3a&"
import script from "./LatestCategoryItem.vue?vue&type=script&lang=js&"
export * from "./LatestCategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports